import { useMutation } from "@tanstack/react-query";
import { useNavigationHandler } from "../contexts/Navigation";
import { CreateOrUpdateSFOSteps } from "../services/OnboardingSteps";

// Global reusable mutation function
const useGenericMutation = (mutationFn) => {
  return useMutation({ mutationFn: mutationFn });
};

// Define a specific function for tracking SFO steps
export const useTrackSFOSteps = () => {
  const { currentStep, currentSection } = useNavigationHandler();

  const mutationFn = () => {
    return CreateOrUpdateSFOSteps({
      apiPayload: {
        step: currentSection || 1,
        sub_step: currentStep || 1,
      },
    });
  };

  return useGenericMutation(mutationFn);
};
